import { render, staticRenderFns } from "./internet-sources.vue?vue&type=template&id=e0b35cd4&"
import script from "./internet-sources.vue?vue&type=script&lang=ts&"
export * from "./internet-sources.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports